import { render, staticRenderFns } from "./SearchPotentialCustomerModal.vue?vue&type=template&id=18d38b11&scoped=true&"
import script from "./SearchPotentialCustomerModal.vue?vue&type=script&lang=js&"
export * from "./SearchPotentialCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchPotentialCustomerModal.vue?vue&type=style&index=0&id=18d38b11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d38b11",
  null
  
)

export default component.exports